export default {
  qrcode: '二維碼',
  qrcodePlaceholder: '請輸入二維碼編號',
  batchNo: '碼批次',
  batchNoPlaceholder: '請輸入碼批次號',
  userInfo: '用戶信息',
  userInfoPlaceholder: '請輸入用戶名稱或UID',
  productName: '產品名稱',
  productNamePlaceholder: '請輸入產品名稱',
  region: '掃碼國家/地區',
  regionPlaceholder: '請選擇',
  scanTime: '掃碼時間',
  startTime: '開始時間',
  endTime: '結束時間',
  export: '導出',
  colQrcode: '二維碼',
  colBatchNo: '二維碼批次',
  colScanCount: '被查詢次數',
  colUserInfo: '用戶信息',
  colProductInfo: '產品信息',
  colScanTime: '掃碼時間',
  colScanRegion: '掃碼地區',
  colScanIp: '掃碼IP',
  firstScan: '首次',
  nthScan: '第{count}次',
  emptyText: '暫無掃碼記錄',
  isRepetition: '掃碼次數',
  isRepetitionPlaceholder: '請選擇',
  repeatedScan: '重複掃碼',
  qrcodeType: '二維碼類型',
  qrcodeTypePlaceholder: '請選擇',
  qrcodeTypeBig: '大標',
  qrcodeTypeMid: '中標',
  qrcodeTypeSmall: '小標',
  qrcodeTypeAntiFake: '防偽',
};
